import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3aea6c04"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled", "type", "data-test"]
const _hoisted_2 = { class: "spinner" }

import { computed, withDefaults } from 'vue'
import Icon from '@/components/atoms/Icon.vue'
import Spinner from '@/components/atoms/Spinner.vue'
import HoverToolTip from '@/components/molecules/HoverToolTip.vue'

type PropsType = {
  dataTest?: string
  iconColor?: string
  icon?: string
  bgColor?: string
  useBorder?: boolean
  useCircle?: boolean
  disabled?: boolean
  loading?: boolean
  size?: string
  type?: string
  toolTipText?: string
  toolTipWidth?: number
  borderColor?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'IconButton',
  props: {
    dataTest: null,
    iconColor: { default: '' },
    icon: null,
    bgColor: { default: '' },
    useBorder: { type: Boolean, default: true },
    useCircle: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    size: { default: 'M' },
    type: { default: 'button' },
    toolTipText: null,
    toolTipWidth: { default: 120 },
    borderColor: null
  },
  emits: ['click'],
  setup(__props: any) {

const props = __props as { dataTest?: string, iconColor: string, icon?: string, bgColor: string, useBorder: boolean, useCircle: boolean, disabled: boolean, loading: boolean, size: string, type: string, toolTipText?: string, toolTipWidth: number, borderColor?: string };





const buttonClass = computed<{ [key: string]: boolean }>(() => ({
  border: props.useBorder,
  circle: props.useCircle,
  border_color_primary: props.borderColor === 'color-primary',
  border_color_dark1: props.borderColor === 'color-dark1',
  border_color_dark2: props.borderColor === 'color-dark2',
  border_color_red: props.borderColor === 'color-red',
  primary: props.bgColor === 'primary',
  gray: props.bgColor === 'gray',
  white: props.bgColor === 'white',
  black: props.bgColor === 'black',
}))

const style = computed<{ [key: string]: string | undefined }>(() => {
  if (props.size === 'S') {
    return {
      width: '22px',
      height: '22px',
    }
  }

  return {}
})

const iconSize = computed<string>(() => (props.size === 'S' ? '16' : ''))
const spinnerSize = computed<string>(() => (props.size === 'S' ? '15px' : '30px'))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, [
    _createVNode(HoverToolTip, {
      "tool-tip-text": __props.toolTipText,
      width: __props.toolTipWidth
    }, {
      default: _withCtx(() => [
        _createElementVNode("button", {
          class: _normalizeClass(["icon-btn", _unref(buttonClass)]),
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('click')), ["stop"])),
          disabled: __props.disabled,
          style: _normalizeStyle(_unref(style)),
          type: __props.type,
          "data-test": __props.dataTest
        }, [
          (!__props.loading)
            ? (_openBlock(), _createBlock(Icon, {
                key: 0,
                class: "link_scale_m",
                type: __props.icon,
                color: __props.iconColor,
                size: _unref(iconSize)
              }, null, 8, ["type", "color", "size"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            (__props.loading)
              ? (_openBlock(), _createBlock(Spinner, {
                  key: 0,
                  color: __props.iconColor,
                  size: _unref(spinnerSize)
                }, null, 8, ["color", "size"]))
              : _createCommentVNode("", true)
          ])
        ], 14, _hoisted_1)
      ]),
      _: 1
    }, 8, ["tool-tip-text", "width"])
  ]))
}
}

})